import { isAndroid, isIOS, isMacOs, isWindows } from "react-device-detect";

export function getOrCreateDeviceId(): string {
    const key = "cm_device_id";
    let id = localStorage.getItem(key);
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(key, id);
    }
    return id;
}

export function getDeviceMeta() {
    let platform = "web";
    if (isIOS) platform = "iOS";
    else if (isAndroid) platform = "Android";
    else if (isMacOs) platform = "macOS";
    else if (isWindows) platform = "Windows";
    const browser = getBrowserName(
        typeof navigator !== "undefined" ? navigator.userAgent : undefined
    );
    const deviceName = `${platform}${browser ? ` * ${browser}` : ""}`.trim();
    return { platform, deviceName };
}

export function getBrowserName(ua?: string): string {
    if (!ua) return "";
    const s = ua.toLowerCase();
    if (s.includes("edg")) return "Edge";
    if (s.includes("opr") || s.includes("opera")) return "Opera";
    if (s.includes("chrome")) return "Chrome";
    if (s.includes("safari") && !s.includes("chrome")) return "Safari";
    if (s.includes("firefox")) return "Firefox";
    if (s.includes("yabrowser")) return "Yandex";
    if (s.includes("trident") || s.includes("msie")) return "IE";
    return "";
}

import { isMobile } from "react-device-detect";

import type { IDeviceData } from "store/reducers/DeviceSlice";

import { SignalRConnectionStatus } from "../SignalR";

import { redirect } from "./links";

export const deviceLoad = (): IDeviceData => {
    const data: IDeviceData = {
        isPWA: deviceIsPWA(),
        screen: {
            size: deviceGetScreenSize(),
            type: "xs",
            name: "mobile",
        },
        signalRStatus: SignalRConnectionStatus.Disconnected,
        isOnline: undefined,
        isDragOverGlobal: false,
        frontVersion: "",
        timeDiff: 0,
        serverDateNow: "",
        localDateNow: "",
        isTimeDiffModalOpen: false,
        isTimeDiffWarningShown: false,
    };
    data.screen.type = deviceGetScreenType(data.screen.size.width);
    data.screen.name = deviceGetScreenName(data.screen.type);
    return data;
};

export const deviceGetScreenSize = (): IDeviceData["screen"]["size"] => {
    return { width: window.innerWidth, height: window.innerHeight };
};
export const deviceGetScreenType = (width: number): IDeviceData["screen"]["type"] => {
    if (width >= 1536) {
        return "xl";
    }
    if (width >= 1200) {
        return "lg";
    }
    if (width >= 900) {
        return "md";
    }
    if (width >= 600) {
        return "sm";
    }
    return "xs";
};
export const deviceGetScreenName = (screenType: IDeviceData["screen"]["type"]) => {
    if (!isMobile) {
        switch (screenType) {
            case "xl":
            case "lg":
            case "md": //big
                return "big";
        }
        return "normal";
    }
    return "mobile";
};

export function deviceOpenWhatsApp(phoneNumber: string) {
    redirect(getWhatsAppLink(phoneNumber));
}
function getWhatsAppLink(phoneNumber: string) {
    return `https://wa.me/${phoneNumber}`;
}
export function getTelegramLink(contactValue?: string) {
    if (!contactValue) return undefined;
    const value = contactValue.trim();
    if (!value) return undefined;
    if (value.startsWith("@")) {
        return `https://t.me/${value.substring(1)}`;
    }
    if (value.includes("t.me/") || value.includes("telegram.me/")) {
        return value;
    }
    // Telegram открывает чаты по номеру телефона с префиксом t.me
    return `https://t.me/${value}`;
}
export function deviceOpenTelegram(telegramLogin: string) {
    const link = `https://t.me/${telegramLogin}`;
    redirect(link, true);
}
export function deviceIsPWA() {
    return (
        window.matchMedia("(display-mode: window-controls-overlay)").matches ||
        window.matchMedia("(display-mode: standalone)").matches
    );
}
